export enum BREAKPOINTS {
  xs = 576,
  sm = 768,
  md = 992,
  lg = 1200,
}
